<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p>액션 활동 공지 {{ state.idx === 0 ? "등록" : "수정" }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sign_form custom_scroll activity">
            <ul>
                <li>
                    <label for="isNotice2" class="checkbox_wrap2">
                        <input id="isNotice2" type="checkbox" v-model="state.data.isNotice" :true-value="1" :false-value="0" />
                        <em></em>
                        <span>공지 여부</span>
                    </label>
                </li>

                <li>
                    <label for="isSecret" class="checkbox_wrap2">
                        <input id="isSecret" type="checkbox" v-model="state.data.isSecret" :true-value="1" :false-value="0" />
                        <em></em>
                        <span>비밀글 여부</span>
                    </label>
                </li>

                <li v-if="state.data.isSecret === 1">
                    <label for="pw" class="form_li_tit">비밀번호</label>
                    <input id="pw" type="password" v-model="state.data.pw" placeholder="비밀번호를 입력해주세요." />
                </li>

                <li>
                    <label for="title" class="form_li_tit">제목</label>
                    <input id="title" type="text" v-model="state.data.title" placeholder="제목을 입력해주세요." />
                </li>
                <li class="li_con">
                    <label for="editor1" class="form_li_tit" aria-placeholder="내용을 입력해주세요.">내용</label>
                    <textarea id="editor1" name="editor1" class="custom_scroll" v-model="state.data.content"></textarea>
                </li>
                <li class="file_wrap">
                    <span class="form_li_tit">첨부</span>
                    <label for="area_file">
                        <input id="area_file" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                        <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하거나 파일을 드래그하여 첨부해주세요</div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                        <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                    </label>
                    <div class="file_list">
                        <div class="file" v-for="(item, idx) in state.data.fileList" :key="idx">
                            <img class="file_item" :src="item.file" alt="" @click="showImgModal(item.file)" />
                            <button class="file_del icon_wrap" @click="fileRemove(item.idx)">
                                <img src="img/close_02.png" alt="" />
                            </button>
                        </div>

                        <div class="file" v-for="(item, index) in state.file" :key="index">
                            <img class="file_item" :src="CommonUtils.getImgUrl(item)" alt="" @click="showImgModal(CommonUtils.getImgUrl(item))" />
                            <button class="file_del icon_wrap" @click="removeFile(index)">
                                <img src="img/close_02.png" alt="" />
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
            <Comment v-if="state.idx !== 0" :idx="state.idx"></Comment>
        </div>
        <div class="_flex _center btn_wrap">
            <button class="submit_btn _130 _main_blue" v-if="state.idx === 0" @click="add">등록</button>
            <button class="submit_btn _130 _main_blue" v-else @click="modify">수정</button>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts">
    import {
        onMounted,
        reactive,
        watch,
        onUnmounted,
        CommonUtils,
        apiService,
        types,
        getMessageByCode,
        CkEditorManager,
        ModalDefault,
        CommentForAction,
    } from "@/BaseComponent";

    export default {
        props: {
            stateIdx: {
                type: Number,
                defalut: 0,
            },
            idx: {
                type: Number,
                defalut: 0,
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault, Comment: CommentForAction },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                data: {} as any,
                file: [] as Array<File>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            let editorManager: CkEditorManager | null = null;

            onMounted(async () => {
                state.data = {};
                state.idx = props.idx;

                if (state.idx > 0) {
                    await getData();
                }

                if (state.data.isNotice === 1) initEditor();
            });

            onUnmounted(() => {
                editorManager?.destroy();
            });

            watch(props, async () => {
                state.data = {};
                state.idx = 0;
                editorManager = new CkEditorManager("editor1", state.data, "boardAction");
                await editorManager.initEditor();

                editorManager?.setDataInfo(state.data.content);
            });

            const closeModal = () => emit("close");
            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    emit("callback");
                } else {
                    state.isShowModal = false;
                }
            };

            watch(
                () => state.data.isNotice,
                async (isNotice) => {
                    if (isNotice === 1) {
                        initEditor();
                    } else {
                        editorManager?.destroy();
                        editorManager = null;
                        state.data.content = CommonUtils.htmlToText(state.data.content);
                    }
                },
            );

            const initEditor = async () => {
                if (!editorManager) {
                    editorManager = new CkEditorManager("editor1", state.data, "boardAction");
                    await editorManager.initEditor();
                }
                editorManager?.setDataInfo(state.data.content);
            };

            const getData = async () => {
                const res = await apiService.boardAction.detail(state.idx);
                if (res.returnCode === 0) {
                    state.data = res.data;
                    // state.data.content = CommonUtils.decodeContent(res.data.content);
                    if (state.data.isNotice) {
                        editorManager?.setDataInfo(res.data.content);
                    } else {
                        state.data.content = CommonUtils.decodeContent(res.data.content);
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const add = async () => {
                if (checkValue()) {
                    const param: types.ReqBoardAction = {
                        title: state.data.title,
                        content: state.data.content,
                        isNotice: state.data.isNotice,
                        isSecret: state.data.isSecret,
                        pw: state.data.pw,
                        file: state.file,
                    };

                    const res = await apiService.boardAction.add(props.stateIdx, param);

                    if (res.returnCode === 0) {
                        state.modalTab = 7;
                        state.modalTitle = "안내";
                        state.modalContent = "등록이 완료되었습니다.";
                        state.isShowModal = true;
                    } else {
                        console.error(res.description);
                        state.modalTab = -1;
                        state.modalTitle = "안내";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const modify = async () => {
                if (checkValue()) {
                    const param: types.ReqBoardAction = {
                        title: state.data.title,
                        content: state.data.content,
                        isNotice: state.data.isNotice,
                        isSecret: state.data.isSecret,
                        pw: state.data.pw,
                        file: state.file,
                    };

                    const res = await apiService.boardAction.modify(state.idx, param);

                    if (res.returnCode === 0) {
                        state.modalTab = 7;
                        state.modalTitle = "안내";
                        state.modalContent = "저장이 완료되었습니다.";
                        state.isShowModal = true;
                    } else {
                        console.error(res.description);
                        state.modalTab = -1;
                        state.modalTitle = "안내";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const checkValue = () => {
                let msg = "";

                if (!state.data.title) {
                    msg = "제목을 입력해주세요.";
                } else if (!state.data.content) {
                    msg = "내용을 입력해주세요.";
                }

                if (msg) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = msg;
                    state.isShowModal = true;
                    return false;
                } else return true;
            };

            const removeFile = (index: number) => state.file.splice(index, 1);

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                const file = e.target.files[0];
                if (!file) return;

                if (!file.type.startsWith("image/")) {
                    e.target.value = "";
                    return;
                }
                state.file = Array.from(e.target.files);
                target.value = "";
            };

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.boardAction.removeForFile(state.data.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = state.data.fileList.findIndex((item: any) => item.idx === idxFile);
                    if (index !== -1) {
                        state.data.fileList.splice(index, 1);
                    }
                }
            };

            const showImgModal = (imgUrl: string) => {
                state.modalTab = 11;
                state.modalTitle = "이미지";
                state.modalContent = imgUrl;
                state.isShowModal = true;
            };
            return { state, closeModal, callBackModal, CommonUtils, add, modify, handleFiles, removeFile, fileRemove, showImgModal };
        },
    };
</script>
<style scoped>
    label.checkbox_wrap2 > span {
        margin-left: 5px;
    }

    #pw {
        width: 200px;
        max-width: 200px;
    }

    .custom_scroll.activity {
        max-height: 590px;
    }

    .pop_up .activity {
        width: 100%;
    }

    div.file {
        display: flex;
    }
    .file img.file_item {
        width: 100px;
        height: 100px;
        object-fit: contain;
        cursor: pointer;
    }

    .sign_form textarea {
        height: 271px;
        margin-left: 0;
        flex: 1;
    }
    .li_con :deep(#cke_editor1) {
        flex: 1;
    }
</style>
